import React, { useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import { FaSignInAlt } from 'react-icons/fa';
import { useAuth } from '../contexts/AuthContext';
import LoginView from '../views/LoginView';
import navWorld from '../assets/android/ui/p4r_nav_world_eye.svg';
import navShop from '../assets/android/ui/p4r_nav_shop.svg';
import navPlayers from '../assets/android/brand/p4r_nav_shark_center.png';
import navBucks from '../assets/android/ui/p4r_nav_bucks.svg';
import navChat from '../assets/android/ui/p4r_nav_chat.svg';
import './BottomNav.css';

const tabs = [
  { path: '/feed', label: 'World', icon: navWorld, public: true },
  { path: '/shoparound', label: 'Shop', icon: navShop, public: true },
  { path: '/players', label: 'Players', icon: navPlayers, public: false, center: true },
  { path: '/bucks', label: "Buck's", icon: navBucks, public: true },
  { path: '/messages', label: 'Messages', icon: navChat, public: false },
];

const visiblePrefixes = ['/', '/feed', '/map', '/players', '/shoparound', '/bucks', '/teams', '/tournaments', '/race-room', '/messages', '/profile'];
const poolAccents = ['#f2c200', '#2563eb', '#e53935', '#7c1cff', '#ff8c1a', '#16a34a', '#7a1f1f', '#f8f8f8'];

export default function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, loading } = useAuth();
  const [showLogin, setShowLogin] = useState(false);
  const [accents, setAccents] = useState(() => tabs.map((_, index) => poolAccents[index]));

  const activePath = useMemo(() => {
    if (location.pathname === '/' || location.pathname === '/feed' || location.pathname === '/map') return '/feed';
    if (location.pathname === '/profile') return '/players';
    if (location.pathname.startsWith('/teams') || location.pathname.startsWith('/tournaments') || location.pathname === '/race-room') return '/bucks';
    return location.pathname;
  }, [location.pathname]);

  const visible = visiblePrefixes.some(prefix => prefix === '/' ? location.pathname === '/' : location.pathname === prefix || location.pathname.startsWith(`${prefix}/`));
  if (!visible) return null;

  const go = (tab, index) => {
    if (!loading && !user && !tab.public) {
      setShowLogin(true);
      return;
    }
    setAccents(current => current.map((accent, i) => {
      if (i !== index) return accent;
      const alternatives = poolAccents.filter(next => next !== accent);
      return alternatives[Math.floor(Math.random() * alternatives.length)];
    }));
    navigate(tab.path);
  };

  return (
    <>
      <nav className="p4r-bottom-nav" aria-label="Android-style primary navigation">
        {tabs.map((tab, index) => {
          const active = activePath === tab.path;
          return (
            <button
              key={tab.path}
              type="button"
              className={`p4r-bottom-nav-item ${active ? 'active' : ''} ${tab.center ? 'center' : ''}`}
              onClick={() => go(tab, index)}
              aria-current={active ? 'page' : undefined}
              style={{ '--p4r-tab-accent': accents[index] }}
            >
              <span className="p4r-bottom-nav-glow" />
              <span className="p4r-bottom-nav-lens"><img src={tab.icon} alt="" /></span>
              <span className="p4r-bottom-nav-label">{tab.label}</span>
            </button>
          );
        })}
      </nav>

      <Modal show={showLogin} onHide={() => setShowLogin(false)} centered contentClassName="p4r-bottom-auth-modal">
        <Modal.Header closeButton><Modal.Title><FaSignInAlt /> Sign in</Modal.Title></Modal.Header>
        <Modal.Body><LoginView onClose={() => setShowLogin(false)} onGuest={() => setShowLogin(false)} /></Modal.Body>
      </Modal>
    </>
  );
}
